import React from 'react';
import { Select, MenuItem } from '@material-ui/core';

const UserList = ({ variant = 'full', users = [], selectedUser, handleSelectUser }) => {
  return (
    <>
      {variant === 'full' ? (
        <div style={{ flex: 1, marginRight: '1em' }}>
          <ul className="chatBoxUser">
            {users?.map((user) => (
              <li
                key={user.ID}
                onClick={() => handleSelectUser(user.ID)}
                className={
                  selectedUser === user.ID ? 'chatLiUserSelected' : 'chatLiUser'
                }
              >
                {user.Name} {user.Firstname}
                {user.nbNotRead > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '1em',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'green',
                      color: 'white',
                      borderRadius: '50%',
                      padding: '0.2em 0.5em',
                      fontSize: '0.8em',
                    }}
                  >
                    {user.nbNotRead}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <Select
          value={selectedUser ? selectedUser : ""}
          onChange={(e) => handleSelectUser(e.target.value)}
          displayEmpty
          fullWidth
          style={{ marginBottom: '1em' }}
          MenuProps={{
            PaperProps: {
              style: {
                zIndex: 9999,
              },
            },
          }}
        >
          <MenuItem value="" disabled> Sélectionnez un utilisateur </MenuItem>
          {users?.map((user) => (
            <MenuItem key={user.ID} value={user.ID}>
              {user.Name} {user.Firstname}
              {user.nbNotRead > 0 && (
                <span
                  style={{
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '0.2em 0.5em',
                    fontSize: '0.8em',
                    marginLeft: '0.5em',
                  }}
                >
                  {user.nbNotRead}
                </span>
              )}
            </MenuItem>
          ))}
        </Select>
      )}
    </>
  );
};

export default UserList;
